import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminHome from './AdminHome';
 import { IoCloseSharp } from "react-icons/io5";
 import { BsMenuButtonWideFill } from "react-icons/bs";

const CategoryTableWithEditModal = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null); // For the modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get('/api/edit/categories');
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      try {
        await axios.delete(`/api/edit/categories/${id}`);
        setCategories(categories.filter((category) => category._id !== id));
        alert('Category deleted successfully!');
      } catch (error) {
        console.error('Error deleting category:', error);
      }
    }
  };

  const openModal = (category) => {
    setSelectedCategory(category);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedCategory(null);
    setIsModalOpen(false);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/edit/categories/${selectedCategory._id}`, selectedCategory);
      alert('Category updated successfully!');
      fetchCategories(); // Refresh the list
      closeModal();
    } catch (error) {
      console.error('Error updating category:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedCategory({ ...selectedCategory, [name]: value });
  };

  return (
    <div>
           <div className="tf-page-title">
                <div className="container-full">
                    <div className="heading text-center"> Edit Categories</div>
                </div>
            </div>
            <section className="flat-spacing-11">
                <div className="container">
                    <div className="row">
                   
                        <AdminHome/>
        
                        <div className="admin-style-form col-lg-9">
     
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <thead>
          <tr>
     
            <th style={{ border: '1px solid #ddd', padding: '10px' }}>Category Name</th>
            <th style={{ border: '1px solid #ddd', padding: '10px' }}>Category Code</th>
            <th style={{ border: '1px solid #ddd', padding: '10px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => (
            <tr key={category._id}>
             
              <td style={{ border: '1px solid #ddd', padding: '10px' }}>{category.categoryName}</td>
              <td style={{ border: '1px solid #ddd', padding: '10px' }}>{category.categoryCode}</td>
              <td style={{ border: '1px solid #ddd', padding: '10px' }}>
                <button
                  style={{
                    padding: '5px 10px',
                    marginRight: '10px',
                    backgroundColor: '#007BFF',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => openModal(category)}
                >
                  Edit
                </button>
                <button
                  style={{
                    padding: '5px 10px',
                    backgroundColor: '#DC3545',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleDelete(category._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Edit Modal */}
      {isModalOpen && (
        <div>
          {/* Modal Overlay */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 999,
            }}
            onClick={closeModal}
          ></div>

          {/* Modal Content */}
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '5px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              zIndex: 1000,
              width: '400px',
            }}
          >
            <h2>Edit Category</h2>
            <form onSubmit={handleEditSubmit}>
              <div style={{ marginBottom: '10px' }}>
                <label>Category Name</label>
                <input
                  type="text"
                  name="categoryName"
                  value={selectedCategory.categoryName}
                  onChange={handleInputChange}
                  style={{
                    display: 'block',
                    width: '100%',
                    padding: '8px',
                    marginTop: '5px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                  required
                />
              </div>
              <div style={{ marginBottom: '10px' }}>
       
              </div>
              <div style={{ textAlign: 'right' }}>
                <button
                  type="submit"
                  style={{
                    padding: '8px 15px',
                    backgroundColor: '#28A745',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Save Changes
                </button>
                <button
                  type="button"
                  onClick={closeModal}
                  style={{
                    padding: '8px 15px',
                    backgroundColor: '#6C757D',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    marginLeft: '10px',
                    cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      </div>
      </div>
      </div>
      </section>


        <div className="btn-sidebar-account">
                                    <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                                        <BsMenuButtonWideFill />
                                    </button>
                                </div>
                    
                                <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                                    <div className="canvas-wrapper">
                                        <header className="canvas-header">
                                            <span className="title">SIDEBAR ACCOUNT</span>
                                            {/* <SideNavbaBarDashboard /> */}
                                            <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                                        </header>
                                        
                                        <div className="canvas-body sidebar-mobile-append"> </div>
                                    </div>
                                </div>
      </div>
    
  );
};

export default CategoryTableWithEditModal;
